import { InternalRoleNote, User } from 'types';

export const isNoteAuthor = (note: InternalRoleNote, user: User): boolean => {
  if (user) {
    return note?.created_by?.id === user.id;
  } else {
    return false;
  }
};
